<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="name"
          label="Tên xe tuyến"
          placeholder="Nhập tên xe tuyến"
          :rules="[$rules.required]"
          outlined
          dense
          class="required"
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="py-0">
        <AutocompleteTeacherCard
          v-model="driver"
          return-object
          class="required"
          item-text="title"
          item-value="id"
          label="Giáo viên phụ trách"
          hide-details="auto"
          required
          dense
          outlined
          :syncedValue="driver"
          :rules="[$rules.required]"
        />
      </v-col>

      <v-col class="mt-6 py-0" cols="12">
        <v-select
          v-model="status"
          :items="busStatus"
          clear-icon="mdi-close"
          item-text="title"
          item-value="status"
          label="Chọn tình trạng"
          :rules="[$rules.required]"
          outlined
          dense
          clearable
          class="required"
        />
      </v-col>

      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="maxStudent"
          :rules="[$rules.required]"
          class="required"
          label="Số học sinh tối đa"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea v-model="notes" label="Ghi chú" hide-details="auto" outlined></v-textarea>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'
import AutocompleteTeacher from '@/components/basic/input/AutocompleteTeacher.vue'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard.vue'
import { get } from 'lodash'

export default {
  components: {
    AutocompleteTeacher,
    AutocompleteTeacherCard
  },
  props: {
    busData: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  computed: {
    ...mapState('constant', ['busStatus'])
  },
  data: () => ({
    name: '',
    status: '',
    driver: '',
    phone: '',
    notes: '',
    data: {
      maxStudent: ''
    },
    maxStudent: ''
  }),
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    resetDefault() {
      if (this.busData) {
        this.name = this.busData.name
        this.status = this.busData.status
        this.driver = this.busData.driver
        this.phone = this.busData.phone
        this.maxStudent = this.busData.data.maxStudent
        this.notes = this.busData.notes
      }
    },
    getData() {
      return {
        name: this.name,
        driver: this.driver,
        phone: this.phone,
        status: this.status,
        notes: this.notes,
        data: {
          ...get(this.busData, 'data', {}),
          maxStudent: this.maxStudent
        }
      }
    }
  },
  created() {
    this.resetDefault()
  },
  watch: {
    busData() {
      this.resetDefault()
    }
  }
}
</script>
